<div *ngIf="loading; else elseBlock">
  <hr class="sp" />

  <p>
    {{ 'k002964' | translate }}
  </p>

  <div class="result2-wrappen1">
    <div>
      <div>
        {{ 'k001466' | translate }}
        <fa-icon
          class="pointer blue2"
          icon="info-circle"
          (click)="investObjModal()"
        >
        </fa-icon>
      </div>
      <highcharts-chart [Highcharts]="Highcharts" [options]="options1">
      </highcharts-chart>
      <div>{{ extendedData.investmentObjective.text }}</div>
    </div>
    <div>
      <div>
        {{ 'k002966' | translate }}
        <fa-icon
          class="pointer blue2"
          icon="info-circle"
          (click)="liquidNeedsModal()"
        >
        </fa-icon>
      </div>
      <highcharts-chart [Highcharts]="Highcharts" [options]="options2">
      </highcharts-chart>
      <div>{{ extendedData.liquidityNeeds.text }}</div>
    </div>
    <div>
      <div>
        {{ 'k002965' | translate }}
        <fa-icon
          class="pointer blue2"
          icon="info-circle"
          (click)="riskApetiteModal()"
        >
        </fa-icon>
      </div>
      <highcharts-chart [Highcharts]="Highcharts" [options]="options3">
      </highcharts-chart>
      <div>{{ extendedData.riskAppetite.text }}</div>
    </div>
  </div>

  <hr class="sp" />

  <p>
    {{ 'k002958' | translate }}
  </p>

  <p>
    {{ 'k002959' | translate }}
  </p>

  <p [innerHTML]="optR1"></p>

  <section>
    <section class="heatmap-legend">
      <div *ngFor="let item of commonType" class="heatmap-legend-item">
        <div [ngStyle]="{ 'background-color': item.color }"></div>
        <div>{{ item.label }}</div>
      </div>
    </section>
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="commonOptions2"
      [(update)]="updateFlag"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      "
    ></highcharts-chart>
  </section>
</div>

<ng-template #elseBlock>
  <div class="loading-spinner">
    <tech-loading-peq></tech-loading-peq>
  </div>
</ng-template>
